import React from "react";

const PageToolbar = ({ children, style }) => {
  return (
    <div className="page-toolbar" style={style}>
      {React.Children.map(children, (child, index) => {
        if (!child) {
          return null;
        }
        return (
          <div key={index} className="page-toolbar-item">
            {child}
          </div>
        );
      })}
    </div>
  );
};

export default PageToolbar;
